export { GoogleAnalytics } from '@next/third-parties/google';
